<script>
    export let excerpt = null;
    import * as commonUtil from '../utils/commonUtil.js';
    import { util } from '../utils/excerptsUtil.js';
    import { createEventDispatcher } from 'svelte';

	const dispatch = createEventDispatcher();
    function triggerParentEvent(eventType) {
        dispatch('message', {
			eventType
		});
    }

    async function deleteExcerpt(id) {
        if (!id) {
            throw new Error('Invalid id ' + id + ', current excerpt: ' + JSON.stringify(excerpt));
        }
        let response = await util.deleteExcerpt(id);
        if (response.success) {
            console.log('Deleted excerpt with ID ' + id);
            triggerParentEvent('changed');
        }
    }

    let isMenuActive = false;
    function setActive() {
        isMenuActive = true;
        console.log('Set active');
    }
    function setInactive() {
        isMenuActive = false;
        console.log('Set inactive');
    }

    let hasCopiedSuccessfully = '';
    async function copyExcerpt(excerpt) {
        console.log(excerpt);
        let msgContent = excerpt.excerpt;
        console.log(excerpt.source);
        if (excerpt.source) {
            msgContent = msgContent.concat('\n - ' + excerpt.source);
        }
        const isCopied = await commonUtil.copyContentToClipboard(msgContent);
        if (isCopied) {
            hasCopiedSuccessfully = 'true';
            console.log('Copied excerpt ' + msgContent);
        } else {
            hasCopiedSuccessfully = 'false';
            console.log('Failed to copy excerpt ' + msgContent);
        }
        setTimeout(() => {
            hasCopiedSuccessfully = '';
        }, 3000);
    }
</script>

<!-- svelte-ignore a11y-invalid-attribute -->
<div on:mouseenter={() => {setActive()}} on:mouseleave={() => {setInactive()}}>
    {#if isMenuActive}
        <button class="delete-btn" on:click={deleteExcerpt(excerpt.id)} title="{commonUtil.getDeletionText('excerpt')}">
            ✖
        </button>
        <button class="copy-btn {hasCopiedSuccessfully}" on:click={() => {copyExcerpt(excerpt)}} title="Copy to clipboard">
            📋
        </button>
    {/if}
    <button class="hamburger-btn" title="Menu">
        ☰
    </button>
</div>

<style>
    button {
        background-color: rgb(44, 44, 44);
    }
    button:hover {
        background-color: rgb(63, 63, 63);
    }

    .delete-btn {
        color: rgb(238, 0, 0);
    }
    .hamburger-btn {
        opacity: 0.3;
    }
    .copy-btn.true {
        border: 2px solid green;
    }
    .copy-btn.false {
        border: 2px solid red;
    }
</style>